import { isProcessColonneAffichee, ProcessLibraryColonne } from 'src/app/models/process/process-parametrage';

/** État passé au routeur lors de la création depuis la bibliothèque (`/processus` → `/processus/create`). */
export interface ProcessCreationNavigationState {
  fromProcedureLibrary: true;
  titre: string;
  description: string;
  typeTemporel: ProcessLibraryColonne;
}

export function isProcessCreationNavigationState(
  value: unknown,
): value is ProcessCreationNavigationState {
  return (
    typeof value === 'object' &&
    value !== null &&
    (value as ProcessCreationNavigationState).fromProcedureLibrary === true
  );
}

export function isValidProcessCreationNavigationState(
  value: unknown,
): value is ProcessCreationNavigationState {
  return (
    isProcessCreationNavigationState(value) &&
    typeof value.titre === 'string' &&
    value.titre.trim().length > 0 &&
    isProcessColonneAffichee(value.typeTemporel)
  );
}
